import { render, staticRenderFns } from "./TenantEditForm.vue?vue&type=template&id=519c1363&scoped=true&"
import script from "./TenantEditForm.vue?vue&type=script&lang=js&"
export * from "./TenantEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditForm.vue?vue&type=style&index=0&id=519c1363&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c1363",
  null
  
)

export default component.exports